export const esFechaValida = (dia, mes, anio) => {
  const d = parseInt(dia, 10);
  const m = parseInt(mes, 10);
  const y = parseInt(anio, 10);
  if (Number.isNaN(d) || Number.isNaN(m) || Number.isNaN(y)) return false;
  if (y < 1700 || y > 2100) return false;
  if (m < 1 || m > 12) return false;
  const diasEnMes = new Date(y, m, 0).getDate();
  return d >= 1 && d <= diasEnMes;
};

export const esHoraValida = (hora) => {
  const match = /^(\d{2}):(\d{2})$/.exec(hora || '');
  if (!match) return false;
  const h = parseInt(match[1], 10);
  const min = parseInt(match[2], 10);
  return h >= 0 && h <= 23 && min >= 0 && min <= 59;
};
